import { render, staticRenderFns } from "./cloture.vue?vue&type=template&id=f5165d98&"
import script from "./cloture.vue?vue&type=script&lang=js&"
export * from "./cloture.vue?vue&type=script&lang=js&"
import style0 from "./cloture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports